import { Modal, Button } from "react-bootstrap";

const DeleteDealsStage = ({ show, handleClose, onDelete }) => {
  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      className="delete-modal"
      size="sm"
    >
      <Modal.Header closeButton>
        <Modal.Title>Delete Stage</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <p className="delete-text">
          Are you sure you want to delete this stage?
        </p>

        <div className="footer-actions mt-3">
          <Button variant="light" onClick={handleClose}>
            Cancel
          </Button>
          <Button className="btn-orange" onClick={onDelete}>
            Delete
          </Button>
        </div>
      </Modal.Body>
      <style>
          {
               `
               /* Delete modal */
.delete-modal .modal-content {
  border-radius: 10px;
  padding: 10px;
}

.delete-text {
  font-size: 14px;
  color: #555;
  margin-bottom: 10px;
  text-align: center;
}

/* Buttons same as theme */
.btn-orange {
  background-color: #ff6b00;
  border: none;
  color: #fff;
}

.btn-orange:hover {
  background-color: #e65c00;
}

/* Footer */
.footer-actions {
  display: flex;
  justify-content: center;
  gap: 10px;
}

/* Mobile */
@media (max-width: 768px) {
  .footer-actions {
    flex-direction: column;
  }

  .btn {
    width: 100%;
  }
}`
          }
      </style>
    </Modal>
  );
};

export default DeleteDealsStage;